import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  id: "product-reassign"
}
const _hoisted_6 = { class: "dialog container d-flex flex-column m-0 py-2 reassign-dialog" }
const _hoisted_7 = { class: "d-flex align-items-start gap-1 justify-content-between mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 pb-1 mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Task")
], -1 /* HOISTED */)
const _hoisted_9 = { class: "col-6 pb-1 mb-2" }
const _hoisted_10 = { class: "d-flex align-items-start gap-1 justify-content-between" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 pb-1 mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Patient")
], -1 /* HOISTED */)
const _hoisted_12 = { class: "col-6 pb-1 mb-2" }
const _hoisted_13 = { class: "d-flex align-items-start gap-1 justify-content-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 pb-1 mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Scheduled Date/Time")
], -1 /* HOISTED */)
const _hoisted_15 = {
  key: 0,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_16 = {
  key: 1,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_17 = { class: "d-flex align-items-start gap-1 justify-content-between" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 pb-1 mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Existing User/Employee")
], -1 /* HOISTED */)
const _hoisted_19 = {
  key: 0,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_20 = {
  key: 1,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_21 = { class: "d-flex align-items-start gap-1 justify-content-between" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 pb-1 mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "New User/Employee"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_23 = {
  key: 0,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_24 = {
  key: 1,
  class: "col-7 pb-1 mb-2 reassign-search-box"
}
const _hoisted_25 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_26 = {
  key: 0,
  class: "d-flex justify-content-center mb-3 mt-2"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_SaveNotifyUser = _resolveComponent("SaveNotifyUser")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "full-height": false,
    title: "Reassign Task",
    "application-id": _ctx.visitDetails.Application,
    "show-product-pill": true,
    "show-background": true,
    "use-gray-theme": true
  }, {
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
        : (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.visitDetails.TaskName), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.visitDetails.FirstName) + " " + _toDisplayString(_ctx.visitDetails.LastName), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                (_ctx.visitDetails.StartDateTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.formatDateFromDate(_ctx.visitDetails.StartDateTime)) + " " + _toDisplayString(_ctx.formatTime(_ctx.visitDetails.StartDateTime) + " - " + _ctx.formatTime(_ctx.visitDetails.EndDateTime)), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.formatDateFromDate(_ctx.visitDetails.StartDate)) + " " + _toDisplayString(_ctx.visitDetails.StartTime ? _ctx.formatTime(_ctx.visitDetails.StartTime) : "") + " " + _toDisplayString(_ctx.visitDetails.EndTime ? " - " + _ctx.formatTime(_ctx.visitDetails.EndTime) : ""), 1 /* TEXT */))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                (!_ctx.visitDetails.UserFirstName && !_ctx.visitDetails.UserLastName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Unassigned "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.visitDetails.UserFirstName) + " " + _toDisplayString(_ctx.visitDetails.UserLastName), 1 /* TEXT */))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                (_ctx.preSelectedEmpId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.visitDetails.Employee?.firstName) + " " + _toDisplayString(_ctx.visitDetails.Employee?.lastName), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_TypeaheadInput, {
                        getData: _ctx.employeeListFilter,
                        value: _ctx.scheduleEmployee,
                        onValueChanged: _ctx.changescheduleEmployee,
                        placeholder: "Type to Select User",
                        "show-all-by-default": true,
                        "open-on-focus": true,
                        "dropdown-menu-class": "custom-menu dropdown",
                        onBlurredInput: _ctx.v$.scheduleEmployee?.$touch,
                        class: _normalizeClass(`${!_ctx.v$.scheduleEmployee?.$error ? '' : 'field-invalid'}`)
                      }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlurredInput", "class"]),
                      (_ctx.v$.scheduleEmployee?.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Employee is Required."))
                        : _createCommentVNode("v-if", true)
                    ]))
              ])
            ]),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_ctx.isSaving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _hoisted_29))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-md btn-outline-secondary",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
                        }, "Cancel"),
                        _createElementVNode("button", {
                          class: "btn btn-primary ms-2",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reassignVisit()))
                        }, "Reassign"),
                        _createVNode(_component_SaveNotifyUser, {
                          "agency-id": _ctx.visitDetails?.AgencyId,
                          "button-name": 'Reassign and Notify Employee',
                          onHandleSaveVisit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reassignVisit(true)))
                        }, null, 8 /* PROPS */, ["agency-id"])
                      ]))
                ]))
              : _createCommentVNode("v-if", true)
          ]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}